// Stylesheets
import './assets/scss/site.scss';

import { observePaltTypesetting, paltTypesetting } from './assets/modules/paltTypesetting';
import { hover } from './assets/modules/hover';
import { slideshow } from './assets/modules/slideshow';
import { initPhotoSwipeFromDOM } from './assets/modules/photoswipe-init';

const init = () => {
  paltTypesetting();
  observePaltTypesetting();
  hover();
  slideshow();
  initPhotoSwipeFromDOM('.js-pswp-container');
}

init();
